interface PatientRegistrationData {
	phoneNumber?: unknown;
	email?: unknown;
}

export const conditionalStringOneOfValidation = (
	isChild: boolean,
	firstValue?: unknown,
	secondValue?: unknown,
) => {
	if (isChild) {
		return true;
	}

	const secondValueFilled =
		secondValue &&
		typeof secondValue === 'string' &&
		secondValue.trim().length > 0;
	if (!secondValueFilled) {
		const firstValueFilled =
			firstValue &&
			typeof firstValue === 'string' &&
			firstValue.trim().length > 0;
		return Boolean(firstValueFilled);
	}

	return true;
};

export const phoneNumberOrEmailValidation = (
	isChild: boolean,
	value: PatientRegistrationData,
) => {
	if (isChild) {
		return true;
	}

	const phoneNumber =
		typeof value.phoneNumber === 'string'
			? value.phoneNumber.trim()
			: value.phoneNumber;
	const email =
		typeof value.email === 'string' ? value.email.trim() : value.email;

	return Boolean(phoneNumber || email);
};
